export const SearchPlaceholderText = 'Type to start search';
export const SearchNoDataFoundText = 'No data found';
export const SearchAndUseText = 'Search and use';
export const CreateAndUseText = 'Create and use';
export const emptyMethod = (): void => { /* No action need */ };
export const GetColumnValueKey = '@GET_COLUMN_VALUE_CALLBACK@';
export const OnSaveCallbackKey = '@ON_SAVE_CALLBACK@';
